export default {
  screens: [
    {
      type: 'intro',
      title: '想いをあらわすジュエリー',
      content:
        'ショーメは素晴らしい愛の瞬間に寄り添い、人生の幸福な時間をジュエリーの中に刻みます。',
      idYt: '9RbWHsnfvK0',
      videoCover: 'world/sentimental/video.jpg',
      desktop: {
        cover: 'world/sentimental/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sentimental/mobile-cover-1.jpg',
        contentStyle: { width: '100%' },
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '-27%',
          right: '0',
          left: '0',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/sentimental/perspectiveLeft.jpg',
      middleImg: 'world/sentimental/perspectiveMiddle.jpg',
      rightImg: 'world/sentimental/perspectiveRight.jpg',
      content:
        '強い絆で結ばれながら、束縛されることのない自由な愛を象徴する、新しい「リアン」コレクション。気まぐれに結ばれたリボンのように、軽快で遊び心にあふれ、絶えず生まれ変わる魅力そのものです。',
      cover: 'world/sentimental/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        cover: 'world/sentimental/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/sentimental/shadowMiddle.jpg',
        leftImg: 'world/sentimental/shadowLeft.jpg',
        rightImg: 'world/sentimental/perspectiveRight.jpg',
        cover: 'world/sentimental/mobile-cover-1.jpg',
        coverStyle: {
          width: '100%',
          height: 'auto',
          bottom: '0',
          left: '-18%',
          position: 'absolute'
        }
      },
      content:
        '「リアン」コレクションは、1780年の創業に遡る、ショーメの歴史と深く結び付いたコレクションです。かけがえのない友情、愛、誓いなど、さまざまな想いをあらわすジュエリーの伝統を受け継ぎます。 '
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/jp/worlds/sentimental.js